/**
 * Case-study data model.
 *
 * COMPLIANCE: every record is an anonymised, *situational* example of the
 * kind of work this cluster handles — never a named client, never a quote or
 * testimonial, never a rating. Pages built from these records must render the
 * `CASE_DISCLAIMER_TH` block and must not emit Review / AggregateRating /
 * ClaimReview schema. Turnaround values are always ranges with "โดยประมาณ".
 */

export type CaseStudy = {
  /** stable slug-safe id, unique per service */
  id: string;
  serviceSlug: string;
  serviceTh: string;
  /** additional services the same case also used (may be empty) */
  extraServicesTh: string[];
  /** "ชาวไทย" | "ชาวต่างชาติ" */
  clientKindTh: string;
  nationalityTh: string;
  /** จังหวัดในไทย หรือประเทศที่ลูกค้าอยู่ */
  locationTh: string;
  /** กลุ่มผู้ใช้ เช่น นักเรียน/แรงงาน/คู่สมรส/ธุรกิจ/ผู้เกษียณ */
  audienceTh: string;
  purposeTh: string;
  documentsTh: string[];
  stepsTh: string[];
  obstacleTh: string;
  resolutionTh: string;
  turnaroundTh: string;
  outcomeTh: string;
  topicSlug: string;
  topicTh: string;
};

export type CaseTopic = {
  slug: string;
  th: string;
  /** unique intro copy for this sub-hub */
  introTh: string;
  cases: CaseStudy[];
};

export const CASE_DISCLAIMER_TH =
  "ตัวอย่างเคสในหน้านี้เป็นกรณีศึกษาเชิงสถานการณ์ เรียบเรียงจากรูปแบบงานที่พบบ่อยเพื่อประกอบความเข้าใจขั้นตอน ไม่ระบุตัวบุคคลหรือข้อมูลลูกค้ารายใด ไม่ใช่รีวิวหรือคำรับรองจากลูกค้า และไม่ใช่คำรับประกันผลการพิจารณาของหน่วยงาน ระยะเวลาที่ระบุเป็นช่วงโดยประมาณซึ่งขึ้นกับคิวและดุลพินิจของหน่วยงานปลายทาง";
